export default __webpack_public_path__ + "static/media/tokenomics.03facde1.png";